import { ExternalLink, SearchIcon } from 'lucide-react'
import React from 'react'

import { adminRecordInspector } from 'rails_routes'
import { Badge } from 'slab'
import { AdminComplianceCheckPolicyType } from 'utils/web_api.schemas'

interface EmployerComplianceCheckTypeBadgeProps {
  policyType?: AdminComplianceCheckPolicyType
  policyId?: string
}

const EmployerComplianceCheckTypeBadge: React.FC<EmployerComplianceCheckTypeBadgeProps> = ({
  policyType,
  policyId
}) => {
  if (!policyType) return null

  const getBadgeType = (policyType: string) => {
    switch (policyType) {
      case AdminComplianceCheckPolicyType.KYB:
        return 'caution'
      case AdminComplianceCheckPolicyType.KYC:
        return 'thatch'
      default:
        return 'warning'
    }
  }

  return (
    <Badge
      type={getBadgeType(policyType)}
      leftIcon={SearchIcon}
      actionIcon={ExternalLink}
      onActionClick={policyId ? () => window.open(adminRecordInspector.show({ id: policyId }), '_blank') : undefined}
    >
      {policyType}
    </Badge>
  )
}

export default EmployerComplianceCheckTypeBadge
